import type { LoaderFunctionArgs } from "react-router-dom";
import { Button, Input, Grid, Header, Message, Segment } from 'semantic-ui-react'
import { authProvider } from "../../auth";
import { gql } from '@apollo/client';
import { ApolloClient, InMemoryCache } from '@apollo/client';

import { PATHS } from '../../paths';

import { BACKEND_URL } from '../../config';

import {
  Form,
  redirect,
} from "react-router-dom";

const client = new ApolloClient({
  uri: BACKEND_URL,
  cache: new InMemoryCache(),
});

// Define mutation
const SIGNUP_MUATION = gql`
    mutation CreateUser($code: String!, $userName: String!, $password: String!) {
        createUser(code: $code, userName: $userName, password: $password) {
            token
            refreshToken
        }
    }
`;

function SignUpPage() {
  return (
    <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
    <Grid.Column style={{ maxWidth: 450 }}>
      <Header as='h2' color='teal' textAlign='center'>
        Signup to Joyya
      </Header>
      <Form method="post" replace>
        <Segment stacked>
            <Input fluid icon='user' iconPosition='left' placeholder='Username' control='input' name='username' />
            <br />
            <Input
                fluid
                icon='lock'
                iconPosition='left'
                name='password'
                placeholder='Password'
                type='password'
            />
            <br />
            <Input
              fluid
              icon='key'
              iconPosition='left'
              name='code'
              placeholder='Organisation code'
              control='input'
            />
            <br />
            <Button type="submit" color='teal' fluid size='large'>
                Signup
            </Button>
        </Segment>
      </Form>
      <Message>
        Already have an account? <a href={PATHS.LOGIN}>Login</a>
      </Message>
    </Grid.Column>
  </Grid>
  );
}

async function signupAction({ request }: LoaderFunctionArgs) {
  let formData = await request.formData();
  let code = formData.get("code") as string | null;
  let username = formData.get("username") as string | null;
  let password = formData.get("password") as string | null;

  // Validate our form inputs and return validation errors via useActionData()
  if (!username) {
    return {
      error: "You must provide a username to log in",
    };
  }

  if (!code || code.length < 1) {
    return {
      error: "You need an organisatoin code to signup",
    };
  }

  if (password && password.length < 10) {
    return {
      error: "You must use a password that is atleast 10 characters long",
    };
  }

  // Sign up and redirect to the proper destination if successful.
  try {
    const signupRequest = await client.mutate({ mutation: SIGNUP_MUATION, variables: { userName: username, password, code } });
    if (signupRequest.errors) {
      throw new Error();
    }
    if (signupRequest?.data?.createUser?.token) {
      await authProvider.signin(signupRequest?.data?.createUser?.token, signupRequest?.data?.createUser?.refreshToken);
    }
  } catch (error) {
    // Unused as of now but this is how you would handle invalid
    // username/password combinations - just like validating the inputs
    // above
    return {
      error: "Invalid Signup attempt",
    };
  }

  return redirect(PATHS.ONBOARDING);
}

async function signupLoader() {
  if (authProvider.isAuthenticated()) {
      return redirect(PATHS.ORGANISATIONS);
  }
  return null;
}

export { SignUpPage, signupAction, signupLoader };
